import React, { useEffect, useState, Suspense } from 'react';
import StyledVideoPlayerLazy from './VideoPlayerLazy.styles';
import NoJavascriptMessage from './NoJavascriptMessage/NoJavascriptMessage';
import { VideoPlayerProps } from './typings/VideoPlayerProps';

const VideoPlayer = React.lazy(() => import(/* webpackChunkName: "VideoPlayer" */ './VideoPlayer'));

export default function VideoPlayerLazy(props: VideoPlayerProps) {
    const [mounted, setMounted] = useState(false);
    const { className } = props;

    useEffect(() => {
        setMounted(true);
    }, []);

    if (!mounted) {
        return (
            <StyledVideoPlayerLazy className={className}>
                <noscript>
                    <NoJavascriptMessage />
                </noscript>
            </StyledVideoPlayerLazy>
        );
    }

    return (
        <Suspense fallback={<StyledVideoPlayerLazy className={className} />}>
            <VideoPlayer
                // eslint-disable-next-line react/jsx-props-no-spreading
                {...props}
                className={className}
            />
        </Suspense>
    );
}
